import React from 'react'
import { BreachEvent } from '@news-mono/web-common'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import { SimpleTextBanner } from '../../../../../banners/SimpleTextBanner/SimpleTextBanner'
import { TextLink } from '../../../../../typography/TextLink/TextLink'
import BlackFridayBreachContent from './BlackFridayBreachContent'

export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export function BlackFridayBreachNotification({
    articleId,
    breachDeal,
    breachCreativeName,
    onEvent,
}: BreachNotificationProps) {
    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BlackFridayBreachContent
                breachDeal={breachDeal}
                articleId={articleId}
                breachCreativeName={breachCreativeName}
                onEvent={onEvent}
                title="50% off subscriptions."
                message={<p>Ends midnight Monday.</p>}
                cta="View Packages"
                subscriptionPackages={[
                    {
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: breachDeal,
                        onEvent: onEvent,
                        packagePath: 'offercheck/thewest',
                        offerCode: 'BLKFRI1',
                        pretitle: 'Digital',
                        originalPrice: '$1 a day',
                        heading: 'Everyday Digital',
                        price: '50c per day',
                        priceQualifier: 'for 8 weeks*',
                        packageType: 'digital',
                    },
                    {
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: breachDeal,
                        onEvent: onEvent,
                        ribbonTitle: 'Most popular',
                        pretitle: 'Digital & Print',
                        heading: 'Weekend Papers + Everyday Digital',
                        originalPrice: '$9 per week',
                        price: '$4.50 per week',
                        priceQualifier: 'for 8 weeks*',
                        packagePath: 'offercheck/thewest',
                        offerCode: 'BLKFRI2',
                        packageType: 'digitalprint',
                    },
                ]}
            />

            <SimpleTextBanner>
                <p>
                    All subscriptions include exclusive subscriber offers,
                    events and giveaways with West Rewards, our subscriber
                    rewards program.
                </p>
                <p>
                    Need Help?{' '}
                    <TextLink href="tel:1800 811 855">1800 811 855</TextLink>.
                </p>
            </SimpleTextBanner>
        </div>
    )
}
